import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'small';
}

const ComicCard = ({ comic, size = 'normal' }: ComicCardProps) => {
  const ratingColor =
    comic.rating >= 4.7
      ? 'bg-primary-500'
      : comic.rating >= 4.3
        ? 'bg-accent-500'
        : 'bg-secondary-500';

  return (
    <Link
      to={`/article/article-${comic.id.replace('comic-', '')}`}
      className="group block no-underline cursor-pointer"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${size === 'small' ? 'aspect-[3/4]' : 'aspect-[5/7]'}`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国漫画推荐`}
          title={`${comic.title} - ${comic.author}作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <div className="absolute top-2 left-2 flex gap-1.5 flex-wrap">
          {comic.isHot && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-50 dark:text-foreground-950">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 dark:text-foreground-950">
              新作
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${comic.status === '已完结' ? 'bg-secondary-500 text-background-50 dark:text-foreground-950' : 'bg-background-50/90 text-foreground-700'}`}>
            {comic.status}
          </span>
        </div>
      </div>

      <div className="mt-3 space-y-1.5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 font-heading group-hover:text-primary-600 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600">{comic.author}</p>
        <div className="flex items-center gap-2">
          <span className={`w-5 h-5 rounded flex items-center justify-center ${ratingColor}`}>
            <span className="text-[10px] font-bold text-background-50 dark:text-foreground-950">
              {comic.rating}
            </span>
          </span>
          <span className="text-xs text-foreground-500">
            {comic.views >= 10000
              ? `${(comic.views / 10000).toFixed(1)}万阅读`
              : `${comic.views}阅读`}
          </span>
        </div>
        {size === 'normal' && (
          <div className="flex flex-wrap gap-1">
            {comic.tags.map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 rounded text-[10px] bg-secondary-100 text-secondary-700"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default ComicCard;